export default "__VITE_ASSET__75907ade__"